import type {
  BrandSpecials,
  MaterializedMenuProduct,
} from '@iheartjane/data-access';
import type { SmartSortProduct } from '@iheartjane/dm-sdk';
import { FLAGS } from '@iheartjane/feature-flags';
import { forwardRef } from 'react';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import type { ShouldShowWeightFilter } from '@jane/bloom/utils/specials/shouldShowWeight';
import type { ProductSearchResultViewModel } from '@jane/bloom/viewModels/productSearch';

import { LegacyProductCard } from './legacyProductCard';
import { MenuProductCard } from './menuProductCard';

export type ProductCardProps = {
  brandSpecials: BrandSpecials;
  customRowId?: number;
  isPlacement?: boolean;
  isSponsored?: boolean;
  maxWeightOption?: number | null;
  preloaded?: boolean;
  product: ProductSearchResultViewModel;
  selected?: () => void;
  smartProductInstance?: SmartSortProduct<MaterializedMenuProduct>;
  weightFilter?: ShouldShowWeightFilter;
};

export const ProductCard = forwardRef<HTMLDivElement, ProductCardProps>(
  function ProductCard(props, ref) {
    const { featureFlags } = useRootLoaderData();
    const useMenuCard = Boolean(featureFlags[FLAGS.c2CustomComponents]);

    return useMenuCard ? (
      <MenuProductCard ref={ref} {...props} />
    ) : (
      <LegacyProductCard ref={ref} {...props} />
    );
  }
);
